module.exports = __webpack_public_path__ + "img/erp-logos_0025_netsuite.83c10f4b.jpg";